import DxfArrayScanner, { type ScannerGroup } from '../../DxfArrayScanner';
import { Point3D } from '../../../types';
import * as helpers from '../../ParseHelpers';
import parsePoint from '../../shared/parsePoint';
import type {
    AlignedDimensionEntity,
    AngularDimensionEntity,
    DimensionEntity,
    OrdinateDimensionEntity,
    RadialDiameterDimensionEntity
} from './types';

/**
 * @returns Return `false` if curr is not related to common dimension group
 */
export default function parseDimension(
    entity: DimensionEntity,
    curr: ScannerGroup,
    scanner: DxfArrayScanner,
): void {
    const result = { ...entity };

    switch (curr.code) {
        case 100:
            result.subclassMarker = curr.value;
            break;
        case 280:
            result.version = curr.value;
            break;
        case 2:
            result.name = curr.value;
            break;
        case 10:
            result.definitionPoint = parsePoint(scanner) as Point3D;
            break;
        case 11:
            result.textPoint = parsePoint(scanner) as Point3D;
            break;
        case 12:
            (result as AlignedDimensionEntity).insertionPoint = parsePoint(scanner) as Point3D;
            break;
        case 13:
            (result as AlignedDimensionEntity | AngularDimensionEntity | OrdinateDimensionEntity).subDefinitionPoint1 = parsePoint(scanner) as Point3D;
            break;
        case 14:
            (result as AlignedDimensionEntity | AngularDimensionEntity | OrdinateDimensionEntity).subDefinitionPoint2 = parsePoint(scanner) as Point3D;
            break;
        case 15:
            (result as AngularDimensionEntity | RadialDiameterDimensionEntity).centerPoint = parsePoint(scanner) as Point3D;
            break;
        case 16:
            (result as AngularDimensionEntity).arcPoint = parsePoint(scanner) as Point3D;
            break;
        case 70:
            result.dimensionType = curr.value;
            break;
        case 71:
            result.attachmentPoint = curr.value;
            break;
        case 72:
            result.textLineSpacingStyle = curr.value;
            break;
        case 40:
            (result as RadialDiameterDimensionEntity).leaderLength = curr.value;
            break;
        case 41:
            result.textLineSpacingFactor = curr.value;
            break;
        case 42:
            result.measurement = curr.value;
            break;
        case 1:
            result.text = curr.value;
            break;
        case 50:
            (result as AlignedDimensionEntity).rotationAngle = curr.value;
            break;
        case 52:
            (result as AlignedDimensionEntity).obliqueAngle = curr.value;
            break;
        case 53:
            result.textRotation = curr.value;
            break;
        case 51:
            result.ocsRotation = curr.value;
            break;
        case 210:
            result.extrusionDirection = parsePoint(scanner) as Point3D;
            break;
        case 3:
            result.styleName = curr.value;
            break;
        default:
            helpers.checkCommonEntityProperties(result, curr, scanner);
            break;
    }

    Object.assign(entity, result);
}
